<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: -18px;"><b>KYC</b></h1>





                </div>
            </div>





            <div style="text-align:left;">
                <div>
                    <div style="margin-bottom: 2%;">
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>

                    <div class="table-responsive">
                        <cdk-virtual-scroll-viewport classs="virtual-viewport" itemSize="50" class="virtual-viewport" classs="virtual-viewport">
                        <table class="table" id="CustomerKyc">
                            <thead>
                                <tr>

                                    <th scope="col" style="width: 40%;">Sequence No</th>
                                    <th scope="col" style="width: 40%;">Customer Name</th>
                                    <th scope="col" style="width: 40%;">Brand Name</th>
                                    <th scope="col" style="width: 40%;">Owner Name</th>
                                    <th scope="col" style="width: 40%;">Decision Maker</th>
                                    <th scope="col" style="width: 40%;">Owner Nationality</th>
                                    <th scope="col" style="width: 40%;">Year In bussiness</th>
                                    <th scope="col" style="width: 40%;">Office Timing From</th>
                                    <th scope="col" style="width: 40%;">Office Timing To</th>
                                    <th scope="col" style="width: 40%;">Workshop Timing From</th>
                                    <th scope="col" style="width: 40%;">Workshop Timing To</th>
                                    <th scope="col" style="width: 40%;">Type Of Industry</th>
                                    <th scope="col" style="width: 40%;">Customer has Cefla Machine</th>
                                    <th scope="col" style="width: 40%;">Type Of Work</th>
                                    <th scope="col" style="width: 40%;">Cars On Ground</th>
                                    <th scope="col" style="width: 40%;"> No Of Working Sanders</th>
                                    <th scope="col" style="width: 40%;">Car Model</th>
                                    <th scope="col" style="width: 40%;">General Ambiance</th>
                                    <th scope="col" style="width: 40%;">No Of Booths</th>
                                    <th scope="col" style="width: 40%;">No Of Painters</th>
                                    <th scope="col" style="width: 40%;">No Of Panel Beaters</th>
                                    <th scope="col" style="width: 40%;">No Of Healpers</th>
                                    <th scope="col" style="width: 40%;">Current Supplier</th>
                                    <th scope="col" style="width: 40%;">Current Product Used</th>
                                    <th scope="col" style="width: 40%;">Support Offered By Current Supplier</th>
                                    <th scope="col" style="width: 40%;">Issue With Current Supplier
                                    </th>
                                    <th scope="col" style="width: 50%;">Issue With Current Supplier Reason
                                    </th>
                                    <th scope="col" style="width: 40%;">Current Supplier Pricing Knowledge</th>
                                    <th scope="col" style="width: 40%;">Need Mixing Machine</th>
                                    <th scope="col" style="width: 40%;">Total No Of Employee</th>
                                    <th scope="col" style="width: 40%;">Paint & Quality Knowing</th>
                                    <th scope="col" style="width: 40%;">Previous Rop Delay</th>
                                    <th scope="col" style="width: 40%;">Current Supplier Credit Terms</th>
                                    <th scope="col" style="width: 40%;">Est Total Volume Business</th>
                                    <th scope="col" style="width: 40%;">Est Total Volume Business Conversion</th>
                                    <th scope="col" style="width: 40%;">Customer Purchase Volume</th>
                                    <th scope="col" style="width: 40%;">Payment Style </th>
                                    <th scope="col" style="width: 40%;">Employee Salary On Time </th>
                                    <th scope="col" style="width: 40%;">Proper Accounting System</th>
                                    <th scope="col" style="width: 40%;">No Of Mixers</th>
                                    <th scope="col" style="width: 40%;">No Of SalesMan</th>
                                    <th scope="col" style="width: 40%;">Current Mixing Machine</th>
                                    <th scope="col" style="width: 40%;">Main Mixing Machine</th>
                                    <th scope="col" style="width: 40%;">Other Mixing Machine</th>
                                    <th scope="col" style="width: 40%;">Main Thinner Supplier Name</th>
                                    <th scope="col" style="width: 40%;">Main clearCoast Supplier Name</th>
                                    <th scope="col" style="width: 40%;">Main Silver Supplier Name</th>
                                    <th scope="col" style="width: 40%;">Main 2k White Supplier Name</th>
                                    <th scope="col" style="width: 40%;">Expected Delvery Time</th>
                                    <th scope="col" style="width: 40%;">Created By Name</th>
                                    <th scope="col" style="width: 40%;">Manager Name</th>
                                    <th scope="col" style="width: 40%;">Send For Approval</th>

                                    <th scope="col" style="width: 40%;">Customer Department</th>
                                    <th scope="col" style="width: 40%;">Responsible</th>
                                    <th scope="col" style="width: 40%;">Last 3 Month Sales Average</th>

                                    <th scope="col" style="width: 40%;">Status</th>
                                    <th scope="col" style="width: 40%;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *cdkVirtualFor="let employee of output">
                                    <tr>
                                        <td>{{ employee.sequence_no }}</td>
                                        <td>{{ employee.company_name }}</td>
                                        <td>{{ employee.brand_name }}</td>
                                        <td>{{ employee.owner_name }}</td>
                                        <td>{{ employee.decision_maker_name }}</td>
                                        <td>{{ employee.owner_nationality }}</td>
                                        <td>{{ employee.years_in_business }}</td>
                                        <td>{{ employee.office_timing_from }}</td>
                                        <td>{{ employee.office_timing_to }}</td>
                                        <td>{{ employee.workshop_timing_from }}</td>
                                        <td>{{ employee.workshop_timing_to }}</td>
                                        <td>{{ employee.type_of_industry }}</td>
                                        <td>{{ employee.customer_has_cefla_machine }}</td>
                                        <td>{{ employee.type_of_work }}</td>
                                        <td>{{ employee.cars_on_ground }}</td>
                                        <td>{{ employee.no_of_working_sanders }}</td>
                                        <td>{{ employee.car_model }}</td>
                                        <td>{{ employee.general_ambiance }}</td>
                                        <td>{{ employee.no_of_booths }}</td>
                                        <td>{{ employee.no_of_painters }}</td>
                                        <td>{{ employee.no_of_panel_beaters }}</td>
                                        <td>{{ employee.no_of_healpers }}</td>
                                        <td>{{ employee.current_supplier }}</td>
                                        <td>{{ employee.current_products_used }}</td>
                                        <td>{{ employee.support_offered_by_current_supplier }}</td>
                                        <td>{{ employee.issue_with_current_supplier }}</td>
                                        <td>{{ employee.issue_with_current_supplier_reason }}</td>
                                        <td>{{ employee.current_supplier_pricing_knowledge }}</td>
                                        <td>{{ employee.need_mixing_mechine }}</td>
                                        <td>{{ employee.total_no_of_employees }}</td>
                                        <td>{{ employee.paint_and_quality_knowing }}</td>
                                        <td>{{ employee.previous_rop_delay }}</td>
                                        <td>{{ employee.current_supplier_credit_terms }}</td>
                                        <td>{{ employee.est_total_volume_business }}</td>
                                        <td>{{ employee.est_total_volume_business_conversion }}</td>
                                        <td>{{ employee.total_customer_purchase_volume_per_month }}</td>
                                        <td>{{ employee.payment_style }}</td>
                                        <td>{{ employee.employee_salary_on_time }}</td>
                                        <td>{{ employee.proper_accounting_system }}</td>
                                        <td>{{ employee.no_of_mixers }}</td>
                                        <td>{{ employee.no_of_salesmans }}</td>
                                        <td>{{ employee.current_mixing_machines }}</td>
                                        <td>{{ employee.main_mixing_machine }}</td>
                                        <td>{{ employee.other_mixing_machine }}</td>
                                        <td>{{ employee.main_thinner_supplier_name }}</td>
                                        <td>{{ employee.main_clearcoat_supplier_name }}</td>
                                        <td>{{ employee.main_silver_supplier_name }}</td>
                                        <td>{{ employee.main_2k_white_supplier_name }}</td>
                                        <td>{{ employee.expected_delivery_time }}</td>
                                        <td>{{ employee.created_by_name }}</td>
                                        <td>{{ employee.manager_name }}</td>
                                        <td>{{ employee.send_for_approval }}</td>

                                        <td>{{ employee.customer_department }}</td>
                                        <td>{{ employee.responsible_name }}</td>
                                        <td>{{ employee.last_3_month_sales_average | number:'1.2-2'}}</td>

                                        <td>{{ employee.status }}</td>
                                        <td>
                                            <a class="btn btn-danger btn-sm" href="#" data-toggle="modal"
                                                data-target="#modal-sm" (click)="SetId(employee._id,employee.sequence_no)">
                                                <i class="fas fa-trash">
                                                </i>
                                            </a>
                                        </td>

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </cdk-virtual-scroll-viewport>
                    </div>

                    <!------------------------------------------------------------>
                    <div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
                        <div class="modal-dialog modal-sm">
                            <div class="modal-content">

                                <div class="modal-body">
                                    <p>Are you sure to delete "{{deleteNo}}"?</p>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
                                    <button type="button" class="btn btn-primary" data-dismiss="modal"
                                        (click)="DeleteKyc();">Yes</button>
                                </div>
                            </div>

                        </div>

                    </div>